import { Flex } from "@aircall/tractor";
import styled, { getColor } from "@xstyled/styled-components";

export const StyledFlex = styled(Flex)`
  min-width: min-content;
  overflow: hidden;
  border: 1px solid ${getColor("graphic-default")};
  border-radius: 8px;
`;
